<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-container>
      <b-row align-v="center">
        <b-col cols="auto">
          <v-btn class="btn-return" @click="$router.go(-1)">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i>
            VOLTAR
          </v-btn>
        </b-col>
        <b-col>
          <h1 class="title-pages">CONFIGURAÇÃO DE HOME CARE / FAMÍLIA</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card title="">
            <div class="row">
              <div class="col-md-12">
                <label
                  >ATIVAR NOTIFICAÇÃO NO DASHBOARD PARA SINALIZAR CUIDADOS NÃO
                  PRESCRITOS?</label
                >
                <select
                  v-model="rest_home_config_dashboard_show_prescription_care"
                  class="form-control"
                >
                  <option value="SIM">SIM</option>
                  <option value="NAO">NÃO</option>
                </select>
              </div>
              <div class="col-md-12">
                <label
                  >VISUALIZAR NO DASHBOARD PARA REGISTRAR
                  INTERCORRÊNCIAS?</label
                >
                <select
                  v-model="rest_home_config_dashboard_show_prescription_complication"
                  class="form-control"
                >
                  <option value="SIM">SIM</option>
                  <option value="NAO">NÃO</option>
                </select>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <errors-messages :errors="errors" />
      <b-row align-h="end">
        <b-col cols="auto">
          <confirmation-dialog
            message-title="CONFIRMAÇÃO"
            message-body="TEM CERTEZA QUE DESEJA SALVAR?"
            open-class="btn-save"
            open-text="SALVAR"
            openLeftIcon="fa-check"
            @yes="save"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "ConfigRestHomeDashboard",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],
      rest_home_config_dashboard_show_prescription_care: "SIM",
      rest_home_config_dashboard_show_complication: "SIM",
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      await this.get();
    },

    async get() {
      this.loading = true;

      const response = await api.get(
        "/rest-home/settings/config-rest-home-dashboard"
      );

      const { error, errors, configs } = response.data;

      if (error) {
        this.errors = errors;
      } else {
        this.errors = [];
        if (configs) {
          if (configs.rest_home_config_dashboard_show_prescription_care) {
            this.rest_home_config_dashboard_show_prescription_care =
              configs.rest_home_config_dashboard_show_prescription_care;
          }
          if (
            configs.rest_home_config_dashboard_show_prescription_complication
          ) {
            this.rest_home_config_dashboard_show_prescription_complication =
              configs.rest_home_config_dashboard_show_prescription_complication;
          }
        }
      }
    },

    async save() {
      try {
        this.loading = true;

        let {
          rest_home_config_dashboard_show_prescription_care,
          rest_home_config_dashboard_show_prescription_complication,
        } = this;

        let configs = {
          rest_home_config_dashboard_show_prescription_care,
          rest_home_config_dashboard_show_prescription_complication,
        };

        const data = { configs };

        const response = await api.patch(
          "/rest-home/settings/config-rest-home-dashboard",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message);
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
